var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.qrCode && !_vm.isGenerate)?_c('div',{staticClass:"space-y-4 flex justify-center"},[_c('img',{attrs:{"width":"240px","src":_vm.qrCode,"alt":"Kobla"}})]):_c('div',{staticClass:"text-center mt-6"},[_vm._v(" "+_vm._s(_vm.$t('Generating your QR code...'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }